import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=a6c6b578&"
import script from "./PersonalData.vue?vue&type=script&lang=ts&"
export * from "./PersonalData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports